<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">销售出库</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :customerList="this.$store.state.cache.customerList"
        :factoryList="this.$store.state.cache.factoryList"
      ></v-head>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>数据明细</span>
      </h2>
      <v-list :fromData="fromData" :noFromData="noFromData" ref="listChild"></v-list>
    </div>
  </div>
</template>

<script>
import { customerApi, factoryApi } from "api/base.js";
import { sale, salereturn } from "api/business.js";

import vHead from "./components/add/head.vue";
import vList from "./components/add/list.vue";

import { mapState, mapActions } from "vuex";

export default {
  components: {
    vHead,
    vList
  },
  data() {
    return {
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        details: []
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    //请求初始数据
    this.getStartData();
  },
  methods: {
    ...mapActions("cache", ["clearCache"]),
    handleClick(tab, event) {},
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    async getStartData() {
      //客户
      if (!this.$store.state.cache.customerList) {
        let customerList = await this.$post(
          customerApi.list,
          this.$store.state.getAllPage
        );
        if (customerList.status) {
          customerList.data.list.forEach(item => {
            item.value = item.customerCode + "-" + item.customerName;
          });
          this.$store.state.cache.customerList = customerList.data.list;
        } else {
          this.$store.state.cache.customerList = null;
        }
      }
      //console.log(this.$store.state.cache.customerList,'==444==');
      //工厂列表
      if (!this.$store.state.cache.factoryList) {
        let factoryList = await this.$post(
          factoryApi.list,
          this.$store.state.getAllPage
        );
        if (factoryList.status) {
          factoryList.data.list.forEach(item => {
            item.value = item.factoryCode + "-" + item.factoryDesc;
          });
          this.$store.state.cache.factoryList = factoryList.data.list;
        } else {
          this.$store.state.cache.factoryList = null;
        }
      }

      this.isLoading = false;
    },

    //保存提交数据
    subSave() {
      let vm = this;
      if (!this.fromData.voucherDate) {
        this.$message.error("请选择凭证日期");
        return false;
      }
      if (!this.fromData.postingDate) {
        this.$message.error("请选择过账日期");
        return false;
      }
      if (!this.fromData.factoryId) {
        this.$message.error("请选择正确的工厂");
        return false;
      }
      if (!this.fromData.inventoryId) {
        this.$message.error("请选择正确的工厂库存地");
        return false;
      }
      if (!this.fromData.customerId) {
        this.$message.error("请选择正确的客户");
        return false;
      }
      if (!this.$store.state.cache.selectedMatterStockList.length) {
        this.$message.error("请选择物料明细");
        return false;
      }
      this.fromData.details = [];
      let isTrue = true;
      this.$store.state.cache.selectedMatterStockList.forEach(item => {
        if (!item.quantity) {
          vm.$message.error("请输入销售数量");
          isTrue = false;
          return false;
        }
        if (!item.standardCurrAmount) {
          vm.$message.error("请输入单价");
          isTrue = false;
          return false;
        }
        let quantity = parseInt(item.quantity);
        let standardCurrAmount = parseFloat(item.standardCurrAmount);
        let quantityStr = quantity.toString();
        let standardCurrAmountStr = standardCurrAmount.toString();

        if (standardCurrAmount <= 0 || standardCurrAmountStr === "NaN") {
          vm.$message.error("单价必须大于0");
          isTrue = false;
          return false;
        }
        if (quantity <= 0 || quantityStr === "NaN") {
          vm.$message.error("数量必须大于0整数");
          isTrue = false;
          return false;
        }
        if (quantity > 0) {
          if (item.quantity.split(".").length>1) {
            vm.$message.error("数量不能为小数");
            isTrue = false;
            return false;
          }
        }
        if (standardCurrAmount > 0) {
          let amounts = standardCurrAmountStr.split(".");
          if (amounts.length == 2) {
            if (amounts[1].length > 2) {
              vm.$message.error("单价小数不能大于2位");
              isTrue = false;
              return false;
            }
          }
          item.standardCurrAmount = standardCurrAmount.toFixed(2);
        }
      });
      if (!isTrue) return false;
      this.fromData.details = this.$store.state.cache.selectedMatterStockList;
      this.fromData.voucherDate = this.$moment(
        this.fromData.voucherDate
      ).format("YYYY-MM-DD");
      this.fromData.postingDate = this.$moment(
        this.fromData.postingDate
      ).format("YYYY-MM-DD");

      this.$confirm("确定提交数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.isLoading = true;
          this.loadingBg = "rgba(255,255,255,0.5)";
          this.loadingTxt = "数据处理中...";
          let res = await this.$post(sale.add, this.fromData);
          this.isLoading = false;
          console.log(res);
          if (res.status) {
            this.$confirm(
              "销售出库单号" +
                res.data.materialVoucherCode +
                "创建成功，是否继续出货？",
              "提示",
              {
                confirmButtonText: "继续",
                cancelButtonText: "退出",
                type: "success"
              }
            )
              .then(() => {
                //凭证和过账默认今天
                let nowData = new Date();
                this.fromData = {
                  voucherDate: nowData,
                  postingDate: nowData,
                  details: []
                };
                this.noFromData = {};
                vm.$router.push({ name: "business-sale-add" });
                //清除部分缓存数据
                vm.clearCache();
              })
              .catch(() => {
                vm.$router.push({ name: "business-sale-list" });
                //清除部分缓存数据
                vm.clearCache();
              });
          } else {
            this.$message.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.$message.success("已取消提交数据");
        });
    }
  }
};
</script>

<style lang="stylus" scoped></style>
